import React, { useState, useEffect } from "react";
import Modal from "../../../components/ModalPopup";
import Button from "../../../components/Button";
import { useAuth } from "../../../components/AuthProvider";
import styles from "./OverrideAuditInputModal.module.scss";

const incidentPattern = /^(INC\d+|TASK\d+|NA)$/;

const OverrideAuditInputModal = ({ isOpen, onCancel, onSubmit }) => {
  const [username, setUsername] = useState("");
  const [authState] = useAuth();
  const [incidentNumber, setIncidentNumber] = useState("");
  const [moreInfo, setMoreInfo] = useState("");
  const [incidentTouched, setIncidentTouched] = useState(false);
  const [moreInfoTouched, setMoreInfoTouched] = useState(false);

  useEffect(() => {
    if (authState?.user?.username) {
      setUsername(authState.user.username);
    }
  }, [authState]);

  useEffect(() => {
    if (!isOpen) {
      setIncidentNumber("");
      setMoreInfo("");
      setIncidentTouched(false);
      setMoreInfoTouched(false);
    }
  }, [isOpen]);

  const isIncidentValid = incidentPattern.test(incidentNumber.trim());
  const isMoreInfoValid =
    moreInfo.trim().length > 0 && moreInfo.trim().length <= 150;
  const canSubmit = isIncidentValid && isMoreInfoValid;

  const handleSubmit = () => {
    setIncidentTouched(true);
    setMoreInfoTouched(true);
    if (canSubmit) {
      onSubmit({
        username,
        incidentNumber: incidentNumber.trim(),
        moreInfo: moreInfo.trim()
      });
      onCancel();
    }
  };

  return (
    <Modal open={isOpen} onClose={onCancel}>
      <div className={styles.modalContent}>
        <h2 className={styles.heading}>Enter details for audit purpose</h2>
        <div className={styles.inputSection}>
          {/* Incident Number */}
          <div>
            <div className={styles.label}>Enter Incident number</div>
            <input
              className={styles.input}
              maxLength={20}
              value={incidentNumber}
              onChange={e => {
                // Allow only letters and numbers (no special characters)
                const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                setIncidentNumber(value);
              }}
              onBlur={() => setIncidentTouched(true)}
              placeholder="e.g. INC123456/TASK654321/NA if not applicable"
            />
            {incidentTouched && !isIncidentValid && (
              <div className={styles.error}>
                Enter a valid incident number starting with INC or TASK. If not
                applicable, enter NA.
              </div>
            )}
          </div>
          {/* More Information */}
          <div>
            <div className={styles.label}>Enter Reason</div>
            <textarea
              className={styles.textarea}
              maxLength={150}
              rows={4}
              value={moreInfo}
              onChange={e => {
                // Allow only letters, numbers, spaces, . and ,
                const value = e.target.value.replace(/[^a-zA-Z0-9\s.,]/g, "");
                setMoreInfo(value);
              }}
              onBlur={() => setMoreInfoTouched(true)}
              placeholder="Enter details (max 150 characters)"
            />
            <div
              className={
                moreInfo.length > 150
                  ? `${styles.charCount} ${styles.charCountError}`
                  : styles.charCount
              }
            >
              {moreInfo.length}/150
            </div>
            {moreInfoTouched && !isMoreInfoValid && (
              <div className={styles.error}>
                Provide more information for performing this override
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonRow}>
          <Button primary onClick={handleSubmit} disabled={!canSubmit}>
            Submit details
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </div>
      </div>
    </Modal>
  );
};

export default OverrideAuditInputModal;
